<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-06-28 11:26:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-10 10:57:26
-->
<template>
  <div class="partline_con">
    <div
      :style="{
        background: datas.backColor,
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',

        '--linecolor': datas.lineColor,
        '--lineWeight': datas.lineWeight + 'px',
      }"
    >
      <div
        :class="'line_box line_box_' + datas.styleType"
        :style="{ width: datas.lineLength + 'px' }"
      />
    </div>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
export default {
  name: "Partline",
  props: {
    datas: Object,
  },
};
</script>

<style scoped lang="scss">
.partline_con {
  position: relative;
  .line_box {
    // width: 100%;
    height: var(--lineWeight);
    margin: 0 auto;
    &.line_box_1 {
      border-bottom: var(--lineWeight) solid var(--linecolor);
    }
    &.line_box_2 {
      background-image: linear-gradient(
        to right,
        var(--linecolor) 75%,
        transparent 0%
      ); /* 35%设置虚线点x轴上的长度 */
      background-position: bottom; /* top配置上边框位置的虚线 */
      background-size: 45px var(--lineWeight); /* 第一个参数设置虚线点的间距；第二个参数设置虚线点y轴上的长度 */
      background-repeat: repeat-x;
    }
    &.line_box_3 {
      background-image: linear-gradient(
        to right,
        var(--linecolor) 58%,
        transparent 0%
      ); /* 35%设置虚线点x轴上的长度 */
      background-position: bottom; /* top配置上边框位置的虚线 */
      background-size: 30px var(--lineWeight); /* 第一个参数设置虚线点的间距；第二个参数设置虚线点y轴上的长度 */
      background-repeat: repeat-x;
    }
    &.line_box_4 {
      background-image: linear-gradient(
        to right,
        var(--linecolor) 52%,
        transparent 0%
      ); /* 35%设置虚线点x轴上的长度 */
      background-position: bottom; /* top配置上边框位置的虚线 */
      background-size: 8px var(--lineWeight); /* 第一个参数设置虚线点的间距；第二个参数设置虚线点y轴上的长度 */
      background-repeat: repeat-x;
    }
    &.line_box_5 {
      background-image: linear-gradient(
        to right,
        var(--linecolor) 0,
        var(--linecolor) 50%,
        transparent 50%,
        transparent 70%,
        var(--linecolor) 70%,
        var(--linecolor) 80%,
        transparent 80%,
        transparent 100%
      );
      background-size: 30px var(--lineWeight);
      background-repeat: repeat-x;
    }
    &.line_box_6 {
      background-image: linear-gradient(
        to right,
        var(--linecolor) 0,
        var(--linecolor) 54%,
        transparent 54%,
        transparent 64%,
        var(--linecolor) 64%,
        var(--linecolor) 72%,
        transparent 72%,
        transparent 82%,
        var(--linecolor) 82%,
        var(--linecolor) 90%,
        transparent 90%,
        transparent 100%
      );
      background-size: 50px var(--lineWeight);
      background-repeat: repeat-x;
    }
    // &.line_box_7 {
    //   background-image: linear-gradient(
    //     to right,
    //     var(--linecolor) 0,
    //     var(--linecolor) 65%,
    //     transparent 65%,
    //     transparent 75%,
    //     var(--linecolor) 75%,
    //     var(--linecolor) 90%,
    //     transparent 90%,
    //     transparent 100%
    //   );
    //   background-size: 50px var(--lineWeight);
    //   background-repeat: repeat-x;
    // }
    &.line_box_7 {
      background-image: linear-gradient(
        to right,
        var(--linecolor) 29%,
        transparent 0%
      ); /* 35%设置虚线点x轴上的长度 */
      background-position: bottom; /* top配置上边框位置的虚线 */
      background-size: 3px var(--lineWeight); /* 第一个参数设置虚线点的间距；第二个参数设置虚线点y轴上的长度 */
      background-repeat: repeat-x;
    }
  }
}
</style>
